"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayersListDataDtoGenderEnum = void 0;
exports.instanceOfPlayersListDataDto = instanceOfPlayersListDataDto;
exports.PlayersListDataDtoFromJSON = PlayersListDataDtoFromJSON;
exports.PlayersListDataDtoFromJSONTyped = PlayersListDataDtoFromJSONTyped;
exports.PlayersListDataDtoToJSON = PlayersListDataDtoToJSON;
exports.PlayersListDataDtoToJSONTyped = PlayersListDataDtoToJSONTyped;
/**
 * @export
 */
exports.PlayersListDataDtoGenderEnum = {
    Male: 'male',
    Female: 'female',
    Other: 'other'
};
/**
 * Check if a given object implements the PlayersListDataDto interface.
 */
function instanceOfPlayersListDataDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('teamId' in value) || value['teamId'] === undefined)
        return false;
    if (!('slug' in value) || value['slug'] === undefined)
        return false;
    if (!('firstName' in value) || value['firstName'] === undefined)
        return false;
    if (!('lastName' in value) || value['lastName'] === undefined)
        return false;
    if (!('nationality' in value) || value['nationality'] === undefined)
        return false;
    if (!('gender' in value) || value['gender'] === undefined)
        return false;
    return true;
}
function PlayersListDataDtoFromJSON(json) {
    return PlayersListDataDtoFromJSONTyped(json, false);
}
function PlayersListDataDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'teamId': json['teamId'],
        'slug': json['slug'],
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'displayName': json['displayName'] == null ? undefined : json['displayName'],
        'nationality': json['nationality'],
        'gender': json['gender'],
        'birthDate': json['birthDate'] == null ? undefined : json['birthDate'],
        'imageUrl': json['imageUrl'] == null ? undefined : json['imageUrl'],
    };
}
function PlayersListDataDtoToJSON(json) {
    return PlayersListDataDtoToJSONTyped(json, false);
}
function PlayersListDataDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'teamId': value['teamId'],
        'slug': value['slug'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'displayName': value['displayName'],
        'nationality': value['nationality'],
        'gender': value['gender'],
        'birthDate': value['birthDate'],
        'imageUrl': value['imageUrl'],
    };
}
